import Breadcrumbs from "components/Common/Breadcrumb"
import FullPageLoader from "components/fullPageLoader"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useLazyGetBlogQuery } from "store/api/investors/reports.api"

const BlogView = () => {
  const { id } = useParams()
  const [trigger, { isFetching }] = useLazyGetBlogQuery()
  const [blog, setBlog] = useState(null)

  const getBlog = async () => {
    try {
      const { data } = await trigger({ id }).unwrap()
      setBlog(data)
    } catch (error) {}
  }

  useEffect(() => {
    getBlog()
  }, [])

  if (blog)
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={blog.title} />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {isFetching ? (
                    <FullPageLoader />
                  ) : (
                    <div
                      className="blog-wrapper-section"
                      dangerouslySetInnerHTML={{
                        __html: blog?.blog,
                      }}
                    ></div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
}

export default BlogView
